import React from "react";

import { Wrapper, WrapperWithBottomBar } from "./styles";

const Topbar = ({ withBottomBar, children }) => {
  return withBottomBar ? (
    <WrapperWithBottomBar>{children}</WrapperWithBottomBar>
  ) : (
    <Wrapper>{children}</Wrapper>
  );
};

export default Topbar;
